import "./validation";
import { Fancybox } from "@fancyapps/ui";
import "./metrikaBinder";
import Swiper from "swiper/bundle";

// document.addEventListener("click", async (event) => {
// const fancyEl = event.target.closest("[data-fancybox]");
// if (!fancyEl) return;
// event.preventDefault();
// const { Fancybox } = await import("@fancyapps/ui");

const kpiThumbsSwiper = new Swiper(".kpi-items", {
	spaceBetween: 0,
	slidesPerView: 1,
	speed: 500,
	on: {
		slideChange: function () {
			kpiMainSwiper.slideTo(kpiThumbsSwiper.activeIndex);
		},
	},
	breakpoints: {
		767: {
			slidesPerView: 6,
			spaceBetween: 0,
			watchSlidesProgress: true,
		},
	},
});

const kpiMainSwiper = new Swiper(".kpi-texts-swiper", {
	// spaceBetween: 10,
	slidesPerView: 1,
	centeredSlides: true,
	effect: "fade",
	speed: 500,

	fadeEffect: {
		crossFade: true,
	},
	thumbs: {
		swiper: kpiThumbsSwiper,
	},
	navigation: {
		nextEl: document.querySelector(".kpi-arrows .kpi-arrow_right"),
		prevEl: document.querySelector(".kpi-arrows .kpi-arrow_left"),
	},
});

const departmentThumbsSwiper = new Swiper(".department-thumbs", {
	spaceBetween: 0,
	slidesPerView: 1,
	watchSlidesProgress: true,
	on: {
		slideChange: function () {
			departmentMainSwiper.slideTo(departmentThumbsSwiper.activeIndex);
		},
	},
	breakpoints: {
		640: {
			slidesPerView: 7,
			spaceBetween: 0,
			watchSlidesProgress: true,
		},
	},
});

const departmentMainSwiper = new Swiper(".department-main", {
	slidesPerView: 1,
	centeredSlides: true,
	effect: "fade",
	on: {
		init: function () {
			console.debug("swiper init");
			updateDepartmentArrows(this.activeIndex + 1);
		},

		slideChange: function () {
			console.debug("swiper change");
			updateDepartmentArrows(this.activeIndex + 1);
		},
	},
	fadeEffect: {
		crossFade: true,
	},
	thumbs: {
		swiper: departmentThumbsSwiper,
	},
});

const departmentArrows = {
	first: {
		up: document.querySelector(".department-thumbs-arrow_up.first"),
		middle: document.querySelector(".department-thumbs-arrow_middle.first"),
		down: document.querySelector(".department-thumbs-arrow_down.first"),
	},
	second: {
		up: document.querySelector(".department-thumbs-arrow_up.second"),
		middle: document.querySelector(
			".department-thumbs-arrow_middle.second",
		),
		down: document.querySelector(".department-thumbs-arrow_down.second"),
	},
};

function updateDepartmentArrows(activeSlideIndex) {
	document
		.querySelectorAll(".department-thumbs-arrow")
		.forEach((arrowElement) => {
			arrowElement.classList.remove("active");
		});

	switch (activeSlideIndex) {
		case 2:
			departmentArrows.first.up.classList.add("active");
			break;

		case 3:
			departmentArrows.first.middle.classList.add("active");
			break;

		case 4:
			departmentArrows.first.down.classList.add("active");
			break;

		case 5:
			departmentArrows.first.middle.classList.add("active");
			departmentArrows.second.up.classList.add("active");
			break;

		case 6:
			departmentArrows.first.middle.classList.add("active");
			departmentArrows.second.middle.classList.add("active");
			break;

		case 7:
			departmentArrows.first.middle.classList.add("active");
			departmentArrows.second.down.classList.add("active");
			break;
		case 1:
		default:
			console.debug(activeSlideIndex);
			document
				.querySelectorAll(".department-thumbs-arrow")
				.forEach((arrowElement) => {
					arrowElement.classList.remove("active");
				});
	}
}

const valuesSwiper = new Swiper(".values-swiper", {
	direction: "vertical",
	slidesPerView: 3,
	centeredSlides: true,
	loop: true,
	mousewheel: {
		enabled: true,
	},
});

const casesSwitchButtons = document.querySelectorAll(".cases-switch");

const casesMainSwiper = new Swiper(".cases-swiper", {
	slidesPerView: 1,
	effect: "fade",
	autoHeight: true,

	fadeEffect: {
		crossFade: true,
	},

	on: {
		slideChange(swiperInstance) {
			updateActiveCasesSwitch(swiperInstance.realIndex);
		},
	},
});

function updateActiveCasesSwitch(activeIndex) {
	casesSwitchButtons.forEach((buttonElement, buttonIndex) => {
		buttonElement.classList.toggle(
			"is-active",
			buttonIndex === activeIndex,
		);
	});
}

casesSwitchButtons.forEach((buttonElement, buttonIndex) => {
	buttonElement.addEventListener("click", () => {
		casesMainSwiper.slideTo(buttonIndex);
	});
});

updateActiveCasesSwitch(casesMainSwiper.realIndex);

// const isMobileMediaQuery = window.matchMedia('(max-width: 767px)');

// let galleryThumbsSwiper = null;

// const galleryMainSwiper = new Swiper('.kpi-texts', {
// 	// spaceBetween: 10,
// 	slidesPerView: 1,
// 	effect: 'fade',
// 	fadeEffect: {
// 		crossfade: true,
// 	},
// 	thumbs: {
// 		swiper: thumbsSwiper,
// 	},
// });

// const thumbElements = document.querySelectorAll('.kpi-items. kpi__item');

// function updateActiveThumb(activeIndex)
// {
//     thumbElements.forEach((thumbElement, thumbIndex) => {
//         thumbElement.classList.toggle(
//             'is-active',
//             thumbIndex === activeIndex
//         );
//     });
// }

// function enableMobileThumbsSwiper()
// {
//     if (galleryThumbsSwiper) {
//         return;
//     }

//     galleryThumbsSwiper = new Swiper('.kpi-items', {
//         slidesPerView: 4,
//         spaceBetween: 10,
//         watchSlidesProgress: true,
//         freeMode: true,
//     });

//     galleryMainSwiper.thumbs.swiper = galleryThumbsSwiper;
//     galleryMainSwiper.thumbs.init();
//     galleryMainSwiper.thumbs.update();
// }

// function disableMobileThumbsSwiper()
// {
//     if (!galleryThumbsSwiper) {
//         return;
//     }

//     galleryMainSwiper.thumbs.swiper = null;

//     galleryThumbsSwiper.destroy(true, true);
//     galleryThumbsSwiper = null;
// }

// function handleViewportChange()
// {
//     if (isMobileMediaQuery.matches) {
//         enableMobileThumbsSwiper();
//     } else {
//         disableMobileThumbsSwiper();
//     }
// }

// updateActiveThumb(galleryMainSwiper.activeIndex);

// galleryMainSwiper.on('slideChange', () => {
//     updateActiveThumb(galleryMainSwiper.activeIndex);
// });

// thumbElements.forEach((thumbElement, thumbIndex) => {
//     thumbElement.addEventListener('click', () => {
//         galleryMainSwiper.slideTo(thumbIndex);
//     });
// });

// handleViewportChange();

// isMobileMediaQuery.addEventListener(
//     'change',
//     handleViewportChange
// );

// if (!window._fancyboxBound) {
Fancybox.bind("[data-fancybox]", {
	dragToClose: false,
	closeButton: false,
	autoFocus: false,
	on: {
		"Carousel.ready Carousel.change": function () {
			const slide = Fancybox.getSlide();
			// const trigger = slide.triggerEl;
			const that = slide.el;

			// if (trigger) {
			// const modalType = trigger.dataset.modalType;
			// const currentModalContent = modalsContent[modalType];

			// const formWrapper = that.querySelector("#form-wrapper");
			// const formTitle = that.querySelector("#form-title");
			// const formDescr = that.querySelector("#form-descr");
			// const formInputTitle = that.querySelector("#form-input-title");
			// const formInputDescr = that.querySelector("#form-input-descr");
			// const formButton = that.querySelector("#form-button");
			// const formPrivacy = that.querySelector("#form-privacy-button-text");

			// formWrapper.dataset.modalStyle = currentModalContent.style;
			// formTitle.textContent = currentModalContent.title;
			// formDescr.textContent = currentModalContent.descr;
			// formButton.textContent = currentModalContent.button;
			// formPrivacy.textContent = currentModalContent.button;
			// formInputTitle.value = currentModalContent.title;
			// formInputDescr.value = currentModalContent.descr;
			// }

			const inputTel = that.querySelector(
				".input_tel:not([data-masked])",
			);
			if (inputTel) {
				IMask(inputTel, {
					mask: "+7 (000) 000-00-00",
					lazy: false,
				});
			}
		},
	},
});
// 	window._fancyboxBound = true;
// }
// });
